module.exports = __webpack_public_path__ + "static/media/icons-folder.aa49ec09.svg";